import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { Spinner } from '~/shadcn/ui/spinner'
import { useUser } from '~/@biz_account/useUser/useUser'
import { useMyAmbassador } from './useMyAmbassador'
import { MyAmbassadorDetails } from './components/MyAmbassadorDetails'
import { ClaimAmbassadorForm } from './components/ClaimAmbassadorForm'

function MyAmbassadorPage() {
  const isDesktop = useIsDesktop()
  const { user, isLoading: isUserLoading } = useUser()
  const hasAmbassador = !!user?.profile.myAmbassador?.ambassadorId

  const { query } = useMyAmbassador({ enabled: hasAmbassador })
  const myAmbassador = hasAmbassador ? query.data : null
  const isLoading = isUserLoading || (hasAmbassador && query.isLoading)

  return (
    <PageContainer className="flex flex-col shrink gap-10 w-full pt-10 pb-15 md:pl-40 md:pr-15">
      {isDesktop && <HeadingThree>Môj ambasador</HeadingThree>}

      {isLoading ? (
        <Spinner className="size-8" />
      ) : myAmbassador ? (
        <MyAmbassadorDetails myAmbassador={myAmbassador} />
      ) : (
        <ClaimAmbassadorForm />
      )}
    </PageContainer>
  )
}

export default MyAmbassadorPage
